$(document).ready(function() {
  let checkoutButton = document.getElementById('checkout'),
    rmCheckoutButton = document.getElementById('rm-checkout-btn');
  
  $.ajax({
    type: "POST",
    data: {cart_contents: JSON.stringify(json_cart)},
    url: "https://erp.axparis.co.uk/royalmail/check-cart.php",
    success: function(msg) {
      
      var allow_cc = JSON.parse(msg);
      //var allow_cc = false; // --------- !!! for disabling RM C&C entirely
      
      if(allow_cc){
        
        // Temp Fix !!!! - Force reset required as updating cart currently doesn't mutate the existing checkout object - this forces them to reselect C&C
        $.cookie('rm-collect-point', null);              
        showElement(checkoutButton);
        hideElement(rmCheckoutButton);
        do_click_and_collect();
        // Temp Fix (end) !!!!
        
        // Is cookie containing collect point data set?
        let rm_cookie = $.cookie("rm-collect-point"),
            cookie_data = null;
        if(rm_cookie){
            cookie_data = JSON.parse(rm_cookie);
        }
        if (cookie_data == null) {
            do_click_and_collect();
            hideElement(rmCheckoutButton);
        } 
        else {
            if (cookie_data.isSelected == true) {
                show_existing_collect_point(cookie_data); 

                // Hide Shopify Checkout btn & Show RM Checkout btn
                hideElement(checkoutButton);
                showElement(rmCheckoutButton);
            }
        }
      } 
      else {
            $.cookie('rm-collect-point', null);
      }

    }

  }); 

    // Always try to delete cookie when they use the main checkout button
    $("#checkout").click(function() {
    //$.cookie('rm-collect-point', null);
  });  	
  
});

function init_dialog() {

dialog = $("#dialog-postcode-lookup").dialog({
 autoOpen: false,
 height: 308,
 width: 400,
 modal: true,
 draggable: false,
 resizable: false,
 buttons: {
   Cancel: function() {
     postcode.removeClass("ui-state-error");
     dialog.dialog("close");

     $.cookie('rm-collect-point', null);
     $(this).dialog('destroy');
     do_click_and_collect();

   }
 },
 close: function() {
   postcode.removeClass("ui-state-error");
 }
});

}

function do_click_and_collect(auto=false) {

  $.ajax({
      type: "POST",
      url: "https://erp.axparis.co.uk/royalmail/lookup-postcode-form.php",
      success: function(msg) {
        
          do_click_and_collect_success(msg,auto);      
        
      }
      
  });
  
}

function do_click_and_collect_success(data,do_auto=false){

// Populate div with ajax response (
$('#rm-injection-point').html(data);

tips = $(".validateTips");
postcode = $("#postcode");

$("#rm-click-and-collect").click(function() {    

  init_dialog();
  dialog.dialog("open");

});

$("#submit-postcode").click(function() {   
  
  if (validate()) {

     $.LoadingOverlay("show");
    
    $.ajax({
      type: "POST",
      url: "https://erp.axparis.co.uk/royalmail/show-collect-points.php?postcode="+$.trim($('#postcode').val().replace(/ /g,'')),
      success: function(msg) {

        $.LoadingOverlay("hide");
        
        $('#dialog-postcode-lookup').html(msg);

        dialog.dialog("option", "height", 200);
        
        $("#select-collect-point").change(function() {

          dialog.dialog("option", "height", 640);

          if ($('#select-collect-point').find(":selected").html() == 'Please select...') {

            // reset hidden inputs
            $('#collect-point-details').hide();
            $('#organisationName').val('');
            $('#locationName').val('');
            $('#addressLine1').val('');
            $('#addressLine2').val('');
            $('#city').val('');
            $('#county').val('');
            $('#postcode').val('');

          } else {

            $.LoadingOverlay("hide");
            //console.log(locations_json[$('#select-collect-point').find(":selected").val()]);

            $('#select-collect-point').removeClass("ui-state-error");
            $('#collect-point-details').show();

            selected_collect_point_details = locations_json[$('#select-collect-point').find(":selected").val()];
            selected_collect_point_details.isSelected = true;

            /* Populate inputs */
            $('#distance').val(locations_json[$('#select-collect-point').find(":selected").val()]['distance']+' Miles away.');
            $('#organisationName').val(locations_json[$('#select-collect-point').find(":selected").val()]['organisationName']);
            $('#locationName').val(locations_json[$('#select-collect-point').find(":selected").val()]['locationName']);
            $('#addressLine1').val(locations_json[$('#select-collect-point').find(":selected").val()]['addressLine1']);
            $('#addressLine2').val(locations_json[$('#select-collect-point').find(":selected").val()]['addressLine2']);
            $('#city').val(locations_json[$('#select-collect-point').find(":selected").val()]['city']);
            $('#county').val(locations_json[$('#select-collect-point').find(":selected").val()]['county']);
            $('#postcode').val(locations_json[$('#select-collect-point').find(":selected").val()]['postcode']);

            /* Reorder Opening Hours so in correct weekly format */
            var openingHours = locations_json[$('#select-collect-point').find(":selected").val()]['openingHours'];

            /* Loop Opening hours and generate tbl */
            var table = $('<table>').addClass('opening-times-tbl');
            $(openingHours).each(function(ele, val) {
              var row = '<tr><td>' + val.dayOfWeek + '</td><td>' + val.openingTime + '</td><td>' + val.closingTime + '</td></tr>';
              table.append(row);
            });

            $('#open-times').html(table);


          }
        });


        $("#submit-collect-point").click(function() {

          $.LoadingOverlay("show");              
          
          // Update Shopify Cart Object            
          $.ajax({
              type: "POST",
              data: {cookie_data: JSON.stringify(selected_collect_point_details), cart_contents: JSON.stringify(json_cart)},
              url: "https://erp.axparis.co.uk/royalmail/update-cart-object.php",
              success: function(msg) {
                  
                // Append Generated Checkout URL to JSON to be written to cookie                
                var returnedData = JSON.parse(msg);
                selected_collect_point_details.checkout_url = returnedData.checkout_url;
                
                // Generate 1 hour expiry on cookie
                var now = new Date();
                now.setTime(now.getTime() + 1 * 3600 * 1000);
                
                // Create cookie containing selected collect point
                $.cookie("rm-collect-point", JSON.stringify(selected_collect_point_details), {
                  expires: now,
                  path: ''
                });
                
                
                if(msg.status='ok'){
                  $('#select-collect-point').removeClass("ui-state-error");
                  window.location.replace(selected_collect_point_details.checkout_url);
                } else {
                  //console.log(msg);
                  return false;
                }
                    
                  
              }

          });

        });

      }
    });

  }

  return false;

});	

// Trigger automatically if function called with condition auto = true
if(do_auto){
  $("#rm-click-and-collect").click();
}

}

function show_existing_collect_point(cookie_data){
  let checkoutButton = document.getElementById('checkout'),
  rmCheckoutButton = document.getElementById('rm-checkout-btn');

  $.ajax({
      type: "POST",
      //data: cookie_data,
      data: {cookie_data: cookie_data, surl: surl},
      url: "https://erp.axparis.co.uk/royalmail/get-existing-collect.php",
      success: function(msg) {



          $('#rm-injection-point').html(msg);

          $("#collect-summary-close").click(function() {
              $.cookie('rm-collect-point', null);              
              showElement(checkoutButton);
              hideElement(rmCheckoutButton);
              do_click_and_collect();
          });
        
          $("#rm-populated-click-and-collect").click(function() {
              $.cookie('rm-collect-point', null);
              showElement(checkoutButton);
              hideElement(rmCheckoutButton);
              do_click_and_collect(true);
          });

          $("#collect_change_cp").click(function() {
            $.cookie('rm-collect-point', null);
            showElement(checkoutButton);
            hideElement(rmCheckoutButton);
            do_click_and_collect(true);
          });
      }
      
  });
  
}

function showElement(e){
    if (!e) return;
    e.hidden = false;
}

function hideElement(e){
    if (!e) return;
    e.hidden = true;
}

function updateTips(t) {
  tips
      .text(t)
      .addClass("ui-state-highlight");
  setTimeout(function() {
      tips.removeClass("ui-state-highlight", 1500);
  }, 500);
}

function checkLength(o, n, min, max) {
  if (o.val().length > max || o.val().length < min) {
      o.addClass("ui-state-error");
      updateTips("Length of " + n + " must be between " +	min + " and " + max + ".");
      return false;
  } else {
      return true;
  }
}

function checkPostcode(p) {
    var postcodeRegEx = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
  if(postcodeRegEx.test(p.val())){
    return true;
  } else {
    p.addClass("ui-state-error");
    updateTips("Invalid Postcode.");
    return false;
  }
}

function validate() {
  var valid = true;
  postcode.removeClass("ui-state-error");

  valid = valid && checkLength(postcode, "postcode", 3, 16);
  valid = valid && checkPostcode(postcode);

  if (valid) {
      //console.log(postcode);
      //dialog.dialog( "close" );
  }
  return valid;
}

